import { useEffect, useState } from "react";
import axiosAdmin from "../axiosAdmin";
// ✨ AJOUT DE Megaphone et Send ICI
import { Settings, DollarSign, Users, Lock, Save, TrendingUp, Truck, Megaphone, Send, Trash2} from "lucide-react";

export default function AdminSettings() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState(false);

  const [serviceFee, setServiceFee] = useState("");
  const [deliveryFee, setDeliveryFee] = useState("");
  
  const [sponsorLogo, setSponsorLogo] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  
  // ✨ NOUVEAUX STATES POUR LE BROADCAST
  const [notifTitle, setNotifTitle] = useState("");
  const [notifBody, setNotifBody] = useState("");
  const [isSending, setIsSending] = useState(false);

  const fetchUsers = async () => {
    const res = await axiosAdmin.get("/admin/users?role=client");
    setUsers(res.data.users || []);
  };

  const fetchSettings = async () => {
    const res = await axiosAdmin.get("/admin/settings");
    const { serviceFee: fetchedServiceFee = "", deliveryFee: fetchedDeliveryFee = "",sponsorLogo: fetchedSponsorLogo = "" } = res.data.settings || {};
    setServiceFee(fetchedServiceFee);
    setDeliveryFee(fetchedDeliveryFee);
    setSponsorLogo(fetchedSponsorLogo); // Et mets à jour l'état
  };

  useEffect(() => {
    fetchUsers();
    fetchSettings();
  }, []);

  // ✨ NOUVELLE FONCTION D'ENVOI
  const handleSendBroadcast = async () => {
    if (!notifTitle || !notifBody) {
      alert("Veuillez remplir le titre et le message.");
      return;
    }

    if (!window.confirm("Voulez-vous vraiment envoyer cette notification à TOUS les utilisateurs ?")) return;

    setIsSending(true);
    try {
      await axiosAdmin.post("/admin/settings/broadcast", {
        title: notifTitle,
        body: notifBody,
      });
      alert("🚀 Notification envoyée avec succès !");
      setNotifTitle("");
      setNotifBody("");
    } catch (err) {
      console.error("Erreur broadcast:", err);
      alert("❌ Échec de l'envoi.");
    } finally {
      setIsSending(false);
    }
  };

  const promote = async () => {
    await axiosAdmin.post(`/admin/users/${selectedUser._id}/promote`, {
      adminPassword: password,
    });
    setSelectedUser(null);
    setPassword("");
    setConfirm(false);
    fetchUsers();
  };

  const saveSettings = async () => {
    await axiosAdmin.patch("/admin/settings", {
      serviceFee,
      deliveryFee,
    });
    fetchSettings();
  };

  // La fonction d'upload (très simple) :
  const handleUploadLogoSponsor = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    const formData = new FormData();
    formData.append("logo", file); // ⚠️ Doit être "logo" pour correspondre au backend
  
    setIsUploading(true);
    try {
      // Note : adapte l'URL si axiosAdmin contient déjà "/api/admin"
      const res = await axiosAdmin.patch("/admin/sponsor/logo", formData);
      
      if (res.data.ok) {
        setSponsorLogo(res.data.logoUrl);
        alert("✅ Logo sponsor mis à jour avec succès !");
      }
    } catch (err) {
      console.error("Erreur d'upload :", err);
      alert("❌ Échec de l'upload.");
    } finally {
      setIsUploading(false);
    }
  };

 const handleDeleteSponsorLogo = async () => {
  if (!window.confirm("Voulez-vous vraiment supprimer le logo du sponsor ?")) return;

  setIsUploading(true); // On réutilise le loader d'upload
  try {
    const res = await axiosAdmin.delete("/admin/sponsor/logo");
    
    if (res.data.ok) {
      setSponsorLogo(""); // On vide l'état local
      alert("✅ Logo sponsor supprimé !");
    }
  } catch (err) {
    console.error("Erreur suppression :", err);
    alert("❌ Échec de la suppression.");
  } finally {
    setIsUploading(false);
  }
}; 
  
  return (
    <div className="min-h-screen p-8 space-y-10 font-sans bg-gray-50/50">
      
      {/* ================= EN-TÊTE PAGE ================= */}
      <div className="flex items-center pb-4 border-b border-gray-200">
        <Settings className="mr-3 text-indigo-500" size={32} />
        <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">
          Paramètres et Administration
        </h1>
      </div>

      {/* ================= SECTION 1: FRAIS PLATEFORME ================= */}
      <div className="p-6 space-y-6 bg-white border border-gray-200 shadow-lg rounded-xl">
        <div className="flex items-center pb-3 border-b border-gray-100">
          <DollarSign className="mr-3 text-blue-500" size={24} />
          <h2 className="text-xl font-extrabold text-gray-800">Configuration des Frais Plateforme</h2>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <label className="flex items-center mb-2 text-sm font-semibold text-gray-700">
              <TrendingUp size={16} className="mr-2 text-blue-400" />
              Frais de service (MRU)
            </label>
            <input
              type="number"
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-blue-500"
              value={serviceFee}
              onChange={(e) => setServiceFee(e.target.value)}
            />
          </div>
          <div>
            <label className="flex items-center mb-2 text-sm font-semibold text-gray-700">
              <Truck size={16} className="mr-2 text-blue-400" />
              Frais de livraison (MRU)
            </label>
            <input
              type="number"
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-blue-500"
              value={deliveryFee}
              onChange={(e) => setDeliveryFee(e.target.value)}
            />
          </div>
        </div>
        <div className="flex justify-end pt-4 border-t border-gray-100">
          <button onClick={saveSettings} className="flex items-center px-6 py-2.5 font-bold text-white bg-indigo-600 rounded-xl hover:bg-indigo-700 transition shadow-md">
            <Save size={18} className="mr-2" />
            Enregistrer les Paramètres
          </button>
        </div>
      </div>

      {/* ================= ✨ NOUVELLE SECTION 2: BROADCAST NOTIFICATIONS ================= */}
      <div className="p-6 space-y-6 bg-white border border-gray-200 shadow-lg rounded-xl">
        <div className="flex items-center pb-3 border-b border-gray-100">
          <Megaphone className="mr-3 text-orange-500" size={24} />
          <h2 className="text-xl font-extrabold text-gray-800">Annonces Globales (Push)</h2>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block mb-2 text-sm font-semibold text-gray-700">Titre de la notification</label>
            <input
              type="text"
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-orange-500"
              placeholder="Ex: Nouvelle mise à jour disponible 🚀"
              value={notifTitle}
              onChange={(e) => setNotifTitle(e.target.value)}
            />
          </div>
          <div>
            <label className="block mb-2 text-sm font-semibold text-gray-700">Message</label>
            <textarea
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-orange-500"
              rows="3"
              placeholder="Ex: Profitez de 0 frais de service sur vos 100 prochaines commandes chez Prime Mart !"
              value={notifBody}
              onChange={(e) => setNotifBody(e.target.value)}
            ></textarea>
          </div>
        </div>

        <div className="flex justify-end pt-4 border-t border-gray-100">
          <button 
            onClick={handleSendBroadcast} 
            disabled={isSending}
            className={`flex items-center px-6 py-2.5 font-bold text-white rounded-xl transition shadow-md ${
              isSending ? 'bg-gray-400' : 'bg-orange-500 hover:bg-orange-600'
            }`}
          >
            <Send size={18} className="mr-2" />
            {isSending ? "Envoi en cours..." : "Envoyer à tous les utilisateurs"}
          </button>
        </div>
      </div>
  
      <div className="p-6 mt-8 bg-white border border-gray-200 shadow-lg rounded-xl">
        <h2 className="text-xl font-extrabold text-gray-800 mb-4">Logo du Sponsor (Page Succès)</h2>
        <div className="flex items-center gap-6">
          
          {/* Conteneur avec détection de survol (group) */}
          <div className="relative group w-32 h-32 border-2 border-dashed border-gray-300 rounded-xl flex items-center justify-center bg-gray-50 overflow-hidden shadow-inner">
            {sponsorLogo ? (
              <>
                <img src={sponsorLogo} alt="Sponsor" className="w-full h-full object-contain p-2" />
                
                {/* Le bouton de suppression apparaît au survol grâce à group-hover */}
                <button 
                  onClick={handleDeleteSponsorLogo}
                  className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 backdrop-blur-sm"
                  title="Supprimer le logo"
                >
                  <div className="bg-white p-2 rounded-full text-red-600 shadow-lg transform scale-90 group-hover:scale-100 transition-transform">
                    <Trash2 size={20} />
                  </div>
                </button>
              </>
            ) : (
              <div className="text-center">
                 <span className="text-[10px] text-gray-400 font-bold uppercase">Aucun logo</span>
              </div>
            )}
          </div>
          
          <div className="flex flex-col gap-3">
            <label className={`cursor-pointer bg-indigo-600 text-white px-5 py-2.5 rounded-xl font-bold hover:bg-indigo-700 transition-all shadow-md flex items-center gap-2 ${isUploading ? 'opacity-50 cursor-not-allowed' : 'active:scale-95'}`}>
              {isUploading ? "Traitement..." : "Changer le logo"}
              <input type="file" className="hidden" accept="image/*" onChange={handleUploadLogoSponsor} disabled={isUploading} />
            </label>
            <p className="text-[11px] text-gray-400 leading-tight">
              Format : PNG ou JPG<br/>
              L'image sera centrée automatiquement.
            </p>
          </div>
        </div>
      </div>
      {/* ================= SECTION 3: PROMOTION ADMIN ================= */}
      <div className="p-6 space-y-6 bg-white border border-gray-200 shadow-lg rounded-xl">
        <div className="flex items-center pb-3 border-b border-gray-100">
            <Users className="mr-3 text-red-500" size={24} />
            <h2 className="text-xl font-extrabold text-gray-800">Gestion de la Promotion Administrateur</h2>
        </div>
        {/* ... (Reste de ta table intacte) ... */}
        <div className="overflow-x-auto bg-white border border-gray-100 rounded-xl">
            <table className="w-full text-sm">
            <thead className="text-gray-600 border-b bg-gray-50">
                <tr>
                <th className="px-6 py-3 font-semibold text-left uppercase">Utilisateur (Client)</th>
                <th className="px-6 py-3 font-semibold text-right uppercase">Action</th>
                </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
                {users.map((u) => (
                <tr key={u._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-800">
                    {u.firstName} {u.lastName} — <span className="text-gray-500">{u.phone}</span>
                    </td>
                    <td className="px-6 py-4 text-right">
                    <button
                        onClick={() => { setSelectedUser(u); setConfirm(true); }}
                        className="px-4 py-2 text-sm font-bold text-white bg-red-600 rounded-lg hover:bg-red-700"
                    >
                        Promouvoir admin
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
      </div>

      {/* ================= MODALE DE CONFIRMATION ================= */}
      {confirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-md p-8 space-y-4 bg-white border-t-4 border-red-500 shadow-2xl rounded-2xl">
            <div className="flex items-center pb-2 border-b">
                <Lock className="mr-3 text-red-600" size={24}/>
                <h2 className="text-xl font-extrabold text-red-700">Confirmation d'Action Critique</h2>
            </div>
            <p className="text-sm text-gray-600">
                Vous êtes sur le point de promouvoir **{selectedUser.firstName}** au rôle d'administrateur.
            </p>
            <input
              type="password"
              placeholder="Votre mot de passe admin"
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-red-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="flex justify-end gap-3 pt-2">
              <button onClick={() => { setConfirm(false); setPassword(""); }} className="px-5 py-2 font-medium text-gray-700 bg-gray-200 rounded-xl hover:bg-gray-300">Annuler</button>
              <button onClick={promote} disabled={!password} className={`px-5 py-2 font-bold text-white rounded-xl ${!password ? 'bg-red-300' : 'bg-red-600 hover:bg-red-700'}`}>Confirmer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
